import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/next/Button/Button';
import Icon from 'components/next/Icon/Icon';
import { ProductRiskStatisticsDto } from 'types/dto/contracts-service';
import * as api from 'api/statistics';
import onDownload from 'callbacks/onDownload';

import Card, { cssTitle } from '../Card/Card';
import Chart from './ByRiskChart/ByRiskChart';
import Table from './ByRiskTable/ByRiskTable';
import Switch from '../Switch/Switch';
import { transformData, transformDataForChart } from './ByRisk.model';

interface Props {
  data: ProductRiskStatisticsDto[];
  currency: string;
}

const ByRisk = ({ data, currency }: Props) => {
  const { t } = useTranslation();
  const [isChart, setIsChart] = useState(false);

  const transformedData = useMemo(() => transformData(data), [data]);
  const transformedDataForChart = useMemo(() => transformDataForChart(transformedData), [transformedData]);
  const hasData = Boolean(transformedData.length);

  const onClickExcel = () => {
    onDownload(() => api.printXlsxRiskStatisticsUsingPost(data), {}, t);
  };

  return (
    <Card
      isChart={isChart}
      hasData={hasData}
      title={
        <>
          <span className={cssTitle}>{t('dashboard_extend.byRisk.title')}</span>
          {hasData && (
            <Switch
              checked={isChart}
              onChange={() => {
                setIsChart(!isChart);
              }}
            />
          )}
        </>
      }
      extra={
        hasData && (
          <Button onClick={onClickExcel}>
            <Icon type="excel" color="primary" />
            Excel
          </Button>
        )
      }
    >
      {isChart ? (
        <Chart data={transformedDataForChart} currency={currency} />
      ) : (
        <Table data={transformedData} currency={currency} />
      )}
    </Card>
  );
};

export default ByRisk;
